import React from 'react';
import useSubjectsContext from './context';
import RawHTML from '~/components/jsx-helpers/raw-html';
import useOptimizedImage from '~/helpers/use-optimized-image';
import './about-openstax.scss';
export default function AboutOpenStax({ forceButtonUrl = '', forceButtonText = '', aboutOs }) {
    const { heading, osText: paragraph, linkText: buttonText, linkHref: buttonUrl, image: { file: imgSrc } } = aboutOs;
    const url = forceButtonUrl || buttonUrl;
    const text = forceButtonText || buttonText;
    const optimizedImage = useOptimizedImage(imgSrc, 400);
    return (React.createElement("section", { className: "about-openstax" },
        React.createElement("div", { className: "content" },
            React.createElement("h2", null, heading),
            React.createElement(RawHTML, { html: paragraph }),
            React.createElement("a", { className: "btn primary", href: url }, text),
            React.createElement("img", { src: optimizedImage, alt: "" }))));
}
export function AllSubjectsAboutOpenStax() {
    const { aboutOs } = useSubjectsContext();
    return React.createElement(AboutOpenStax, { aboutOs: aboutOs[0].value });
}
